<template>
  <div class="search-box">
    <el-input
      :placeholder="$t('page.please_input_carrier')"
      size="small"
      prefix-icon="el-icon-search"
      v-model="searchValue">
    </el-input>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchValue: ''
    }
  },
  props: {
    returnData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    searchValue () {
      if (this.searchValue) {
        let searchCarrier = this.returnData.filter(this.filterCarrier)
        // console.log('searchCarrier', searchCarrier)
        if (searchCarrier.length) {
          this.$emit('search-carrier', searchCarrier)
        } else {
          this.$emit('search-carrier', this.$t('page.not_find_carrier'))
        }
      } else {
        this.$emit('search-carrier', [])
      }
    }
  },
  mounted () {

  },
  methods: {
    filterCarrier (item) {
      return item.zhName.indexOf(this.searchValue) !== -1 ||
      item.zhName.toUpperCase().indexOf(this.searchValue) !== -1 ||
      item.zhName.toLowerCase().indexOf(this.searchValue) !== -1 ||
      item.country.cnName.indexOf(this.searchValue) !== -1 ||
      item.country.enName.indexOf(this.searchValue) !== -1 ||
      item.country.enName.toUpperCase().indexOf(this.searchValue) !== -1 ||
      item.country.enName.toLowerCase().indexOf(this.searchValue) !== -1
    }
  }
}
</script>

<style scoped>
  .search-box {
    position: absolute;
    top: 11px;
    right: 60px;
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/searchBox.vue